var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipToCopy = function SvgClipToCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.2,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#026BFF",
    d: "M3.601 3.4h6.4V13h-6.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#026BFF",
    d: "M9.2 1h-8v11.2"
  })));
};
export default SvgClipToCopy;